export default {
  item: {
    loading: false,
    data: {},
    error: {},
  },
}
